// import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useEffect, useRef, useState } from 'react';
import { Grid } from '@/common/grid/Grid';
import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';

export const McoFinTrendChart = ({ selectedPeriod, selectedPbms = [], selectedCtrts = [], isUnits, isPaid, isChart }) => {

  const rsrc = useRsrc();
  const gridRef = useRef();

  const [data, setData] = useState([]);

  const [fieldDefs, setFieldDefs] = useState();
  const [isGridReady, setIsGridReady] = useState(false);

  const [yLabel, setYLabel] = useState();

  useEffect(() => {
    let yLabel;

    if (isPaid) {
      yLabel = 'Paid';
    } else {
      yLabel = 'Dipsute';
    }

    if (isUnits) {
      yLabel += ' Units'
    } else {
      yLabel += ' Dollars'
    }

    setYLabel(yLabel);
  }, [isPaid, isUnits]);

  useEffect(() => {
    if (isChart || !selectedPeriod?.id) {
      return;
    }

    const reqParam = {
      periodId: selectedPeriod.id,
      isUnits
    };

    rsrc.data('sc', 'MCO_FIN_TREND_FIELD_DEFS_DATA_PLUGIN', reqParam).then(fieldDefs => {
      setFieldDefs(fieldDefs);
    });
  }, [isChart, selectedPeriod]);

  useEffect(() => {
    if (!selectedPeriod?.id) {
      return;
    }

    const pbmIds = selectedPbms.map(pbm => pbm.id);
    const ctrtIds = selectedCtrts.map(ctrt => ctrt.id);
    const reqParam = {
      periodId: selectedPeriod.id,
      pbmIds,
      ctrtIds,
      isUnits,
      isPaid,
      isChart
    };

    rsrc.data('sc', 'MCO_FIN_TREND_CHART_DATA_PLUGIN', reqParam).then(data => {
      setData(data);
    });

  }, [selectedPeriod, selectedPbms, selectedCtrts, isUnits, isPaid, isChart]);

  const onGridReady = () => {
    setIsGridReady(true);
  };

  useEffect(() => {
    if (isGridReady && gridRef.current && data) {
      gridRef.current.setDataSource(data);
    }
  }, [isGridReady, data]);

  return (
    <>
      {isChart && (
        <CartesianChart
          data={data}
          yLabel={yLabel}
          xLabel="Rebate Period"
          legend="top"
          allowNegative
        />
      )}

      {!isChart && fieldDefs && (
        <Grid
          ref={gridRef}
          gridOptions={{
            fieldDefs,
            rowModelType: 'clientSide',
            statusBar: null
          }}
          events={{ onGridReady }}
        />
      )}
    </>

  );
};
